export async function handleAttributeValueResource(params) {
    let data = params.data;
    if (typeof params.data.attribute !== 'undefined' && params.data.attribute !== null && typeof params.data.attribute !== 'string') {
        data.attribute = params.data.attribute['@id'];
    }
    return data;
}